import React from 'react';
import { Box, Tooltip } from '@mui/material';
import useInterveneSx from '../hooks/useInterveneSx';

/**
 * Square bordered icon tile — matches records toolbar action style.
 */
export default function InterveneToolbarIconButton({
  title,
  ariaLabel,
  onClick,
  icon,
  disabled = false,
  ariaPressed,
  compact = false,
}) {
  const styles = useInterveneSx().headerAction;

  if (!onClick) return null;

  const label = ariaLabel || title;

  return (
    <Tooltip title={title} arrow placement="top">
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <Box
          component="button"
          type="button"
          aria-label={label}
          aria-pressed={ariaPressed}
          disabled={disabled}
          onClick={onClick}
          sx={compact ? styles.iconTileCompact : styles.iconTile}
        >
          {icon}
        </Box>
      </Box>
    </Tooltip>
  );
}
